import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import React, { useRef, useState } from 'react';
import chevronDownSmallTokens from '@amzn/meridian-tokens/base/icon/chevron-down-small';
import Menu, { MenuItem } from '@amzn/meridian/menu';
import {
  APPROVED_TWP,
  ASSOCIATE_DECISION_PENDING,
  DENIED_TWP,
  INDEFINITE_RESTRICTIONS,
  PLACEMENT_DECISION_PENDING,
  TWP_BUT_PENDING_UPDATED_RESTRICTIONS,
} from 'src/config/AccommodationStatusNames';
import type { AssociateProfilePlacement } from 'src/services/associateProfile/types';

interface UpdateActionsProps {
  placement: AssociateProfilePlacement;
}

const UpdateActions = ({ placement }: UpdateActionsProps) => {
  const updateLinkRef = useRef();
  const [updateMenuOpen, setUpdateMenuOpen] = useState(false);
  const onClickButton = () => setUpdateMenuOpen(true);
  const onClose = () => setUpdateMenuOpen(false);

  const placementSelectionStatuses = [
    PLACEMENT_DECISION_PENDING,
    ASSOCIATE_DECISION_PENDING,
    APPROVED_TWP,
    INDEFINITE_RESTRICTIONS,
    TWP_BUT_PENDING_UPDATED_RESTRICTIONS,
    DENIED_TWP,
  ];

  return (
    <Row spacing="300" alignmentHorizontal="end">
      <Button type="link" ref={updateLinkRef} onClick={onClickButton}>
        Update <Icon tokens={chevronDownSmallTokens} />
      </Button>
      <Menu
        anchorNode={updateLinkRef.current}
        id="update-menu"
        open={updateMenuOpen}
        position="bottom"
        onClose={onClose}
        minWidth="200px"
      >
        <MenuItem onClick={() => console.log('Restriction Dates')}>Restriction Dates</MenuItem>
        <MenuItem onClick={() => console.log('Restrictions')}>Restrictions</MenuItem>
        {placement.accommodationType === 'AUSTIN' && (
          <MenuItem onClick={() => console.log('Initiate Transfer')}>Initiate Transfer</MenuItem>
        )}
        {placementSelectionStatuses.includes(placement.accommodationStatus) && (
          <MenuItem onClick={() => console.log('Placement Selection(s)')}>Placement Selection(s)</MenuItem>
        )}
      </Menu>
    </Row>
  );
};

export default UpdateActions;
